import React from "react";

export const PAGETITLE_LANG = (formatMessage) => {
    let MULTI_LANG = {
        BUTTON_LABEL_TUTORIAL         : formatMessage({id: "pagetitle.button.tutorial", defaultMessage: "튜토리얼"}),
    }
    
    return MULTI_LANG;
};